var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"text-link--primary flex items-center font-bold text-sm leading-3.5",attrs:{"href":_vm.qr && _vm.qr.toDataURL(),"download":"ahaslides-qrcode.png"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }